'use client';
import { ComponentType } from 'react';
import { PlaceholderConfig } from '@spa/lib/react/context/PlaceholderContext';
import { Props } from './brand-alphabet.component';
import dynamic from 'next/dynamic';

const DynamicBrandAlphabetComponent: ComponentType<Props> = dynamic(
  () => import('./brand-alphabet.component')
);

export default DynamicBrandAlphabetComponent;

export function calculateBrandAlphabetPlaceholderConfig(): PlaceholderConfig {
  const heightSinceWidth = [
    { sinceWidth: 0, height: 1000 },
    { sinceWidth: 425, height: 1000 },
    { sinceWidth: 768, height: 1000 },
    { sinceWidth: 1024, height: 1000 },
    { sinceWidth: 1442, height: 1000 }
  ];

  return {
    heightSinceWidth
  };
}
